import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import {
  useGetPayrollStagingDetailQuery,
  useRecalculatePayrollStageMutation,
  useStagingPayrollMutation,
  useUpdatePayrollStageMutation,
} from "AppQuries/payroll/staging";
import { FormProvider, useForm } from "react-hook-form";
import PayrollForm from "Components/Form/PayrollForm";
import PayrollAdditionDeductionForm from "Components/Form/PayrollAdditionDeduction";
import Swal from "sweetalert2";
import { endOfMonth, startOfMonth, format } from "date-fns";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useReGeneratePayrollMutation } from "AppQuries/payroll/generate-payroll";
import { toast } from "core/Operations/toast";
import { Save, RefreshCcw } from "react-feather";
import { useGetPayrollDetailQuery } from "AppQuries/payroll/get-payroll";
// import { RefreshCcw } from "feather-icons-react/build/IconComponents";
const PayrollEdit = () => {
  console.log("PayrollEdit Rendered");
  const userData = useSelector(loggedInUser);
  const { refNo: code, employeeCode } = useParams();
  const [isReGenerated, setIsReGenerated] = useState(false);
  const methods = useForm({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    userName: userData?.userName,
  });
  const navigate = useNavigate();
  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const [filter, setFilter] = useState({
    companyCode: userData.companyCode,
    locationCode: userData.locationCode,
    employeeCode: employeeCode,
    refNo: code,
  });

  const [payrollData, setPayrollData] = useState({});
  const [newPayrollData, setNewPayrollData] = useState([]);

  const {
    mutate: stagingPayroll,
    isError,
    error,
    isPending,
    isFetching,
  } = useStagingPayrollMutation();

  const {
    data: payrollDetail,
    isFetching: isFetchingpayrollDetail,
    isError: ispayrollDetailError,
    error: payrollDetailError,
    refetch: refetchpayrollDetail,
  } = useGetPayrollDetailQuery(
    { ...filter },
    {
      enabled: !!code && !!filter.companyCode && !!filter.locationCode,
    }
  );

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const { mutate: reGeneratePayroll } = useReGeneratePayrollMutation();

  const submitPayroll = () => {
    Swal.fire({
      title: "Confirm to submit?",
      text: "Are you sure you want re-submit payroll",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["No", "Yes"],
    }).then(function (t) {
      if (t.isConfirmed) {
        console.log("payrollData", payrollData);
        let jsonData = [];
        // const selectedPayrollData = payrollData.filter((payroll) =>
        //   selectedRowKeys.includes(payroll.employeeCode)
        // );

        newPayrollData?.forEach((payroll) => {
          jsonData.push({
            companyCode: payroll.companyCode,
            locationCode: payroll.locationCode || userData.locationCode,
            refNo: payroll.refNo,
            employeeCode: payroll.employeeCode,
            icno: payroll.icNo,
            processDateStr: format(new Date(), "yyyy-MM-dd"),
            procesMonth: Number(payroll.procesMonth),
            processYear: Number(payroll.processYear),
            paymentCode: Number(payroll.paymentCode),
            departmentCode: Number(payroll.departmentCode),
            monthlySalary: Number(payroll.monthlySalary),
            basicSalary: Number(payroll.basicSalary),
            grossSalary: Number(payroll.grossSalary),
            addition: Number(payroll.addition),
            deduction: Number(payroll.deduction),

            // totalCpf: Number(payroll.totalCPF),
            // employeeCpf: Number(payroll.employeeCPF),
            // employerCpf: Number(payroll.employerCPF),
            totalCpf: Number(payroll.totalPercentage) ?? 0,
            employeeCpf: Number(payroll.employeePercentage) ?? 0,
            employerCpf: Number(payroll.employerPercentage) ?? 0,
            leaveTakenInDays: Number(payroll.leaveTakenInDays),
            leaveSalaryAmount: Number(payroll.leaveSalaryAmount),
            netPay: Number(payroll.netPay),
            contributionCode: payroll.contributionCode,
            agencyAmount: Number(payroll.agencyAmount),
            sdlAmount: Number(payroll.sdlAmount),
            noOfDaysInMonth: Number(payroll.noOfDaysInMonth),
            noOfWorkingDays: Number(payroll.noOfDaysInMonth),
            hourlySalary: Number(payroll.hourlySalary),
            additionalHours: Number(payroll.additionalHours),
            deductionHours: Number(payroll.deductionHours),
            otHourlySalary: Number(payroll.otHourlySalary),
            noOfOTWorkingDays: Number(payroll.noOfOTWorkingDays),
            // otDaySalary: Number(payroll.otDaySalary),
            otDaySalary: payroll.noOfOTWorkingDaysSalary,
            payrollValue: Number(payroll.payrollValue),
            salaryPayable: Number(payroll.salaryPayable),
            createUser: userData.createUser,
            extraorlessHourAmount: Number(payroll.extraorlessHourAmt),
            daySalary: Number(payroll.daySalary),
            payrollDetail: payroll.payrollDetails, //.length > 0 ? payroll.payrollDetail.map(d => ( {...d})) : []
            waitingTime: Number(payroll.waitingTime) ?? 0,
            waitingTimeSalary: Number(payroll.waitingTimeSalary) ?? 0,
            advancePayment: Number(payroll.advancePayment) ?? 0,
            normalWorkingHoursInMonth:
              Number(payroll.normalWorkingHoursInMonth) ?? 0,
            normalWorkingHoursSalary:
              Number(payroll.normalWorkingHoursSalary) ?? 0,
            oT1Hours: Number(payroll.oT1Hours) ?? 0,
            oT1HourlySalary: Number(payroll.oT1HourlySalary) ?? 0,
            oT2Hours: Number(payroll.oT2Hours) ?? 0,
            oT2HourlySalary: Number(payroll.oT2HourlySalary) ?? 0,
            extraHours: Number(payroll.extraHours) ?? 0,
            extraHoursSalary: Number(payroll.extraHoursSalary) ?? 0,
            publicHolidayOTHours: Number(payroll.publicHolidayOTHours) ?? 0,
            publicHolidayOTHoursSalary:
              Number(payroll.publicHolidayOTHoursSalary) ?? 0,
            paidLeaveDays: Number(payroll.paidLeaveDays) ?? 0,
            paidLeaveSalary: Number(payroll.paidLeaveSalary) ?? 0,
            publicHolidayHours: Number(payroll.publicHolidayHours) ?? 0,
            publicHolidayHoursSalary:
              Number(payroll.publicHolidayHoursSalary) ?? 0,
            leaveAmount: Number(payroll.leaveAmount) ?? 0,
            employeePercentage: Number(payroll.employeePercentage) ?? 0,
            employerPercentage: Number(payroll.employerPercentage) ?? 0,
            levyAmount: Number(payroll.levyAmount) ?? 0,
            payMonth: payroll.payMonth,
          });
        });

        stagingPayroll(jsonData, {
          onSuccess: (response) => {
            if (response[0].response === true) {
              Swal.fire({
                type: "success",
                title: "Payroll Re-Generated!",
                text: "Payroll Re-Generated Successfully..",
                confirmButtonClass: "btn btn-success",
              }).then(function (t) {
                navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: response[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
        });
      }
    });

    setIsReGenerated(false);
  };

  const reCalculate = () => {
    const payload = {
      companyCode: payrollData?.companyCode || 0,
      month: payrollData?.procesMonth.toString() || "",
      year: payrollData?.processYear.toString() || "",
      userCode: userData.userCode || "",
      locationCode: payrollData?.locationCode || 0,
      salaryType: payrollData?.salaryType || 0,
      departmentCode: payrollData?.departmentCode || 0,
      employeeCode: payrollData?.employeeCode || 0,
    };

    reGeneratePayroll(payload, {
      onSuccess: (response) => {
        if (response.length > 0) {
          toast.success("Payroll Recalculated Successfully.");
          setIsReGenerated(true);
          setPayrollData(response[0]);
          setNewPayrollData(response);
          //   navigate(0);
        } else {
          toast.error("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    if (payrollDetail?.employeeHeader?.length > 0) {
      setPayrollData(payrollDetail?.employeeHeader[0]);
    }
  }, [payrollDetail]);

  if (isFetchingpayrollDetail) return <LoadingSpinner />;
  // if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Edit Payroll Staging</h4>
                {/* <h6>Monthly Payroll Summary </h6> */}
              </div>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  className="btn btn-secondary"
                  to={`${all_routes.payroll}${all_routes.payroll_stage}`}
                >
                  <i className="fa fa-reply me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>

          <div className="pay-slip-box" id="pay-slip">
            <div className="modal-dialog modal-dialog-centered stock-adjust-modal">
              <div className="modal-content">
                <div className="page-wrapper-new p-0">
                  <div className="contents">
                    <div className="modal-header border-0 custom-modal-header">
                      <div className="page-header mb-0 w-100">
                        <div className="add-item payslip-list d-flex justify-content-between">
                          <div className="page-title">
                            <h4>Payslip</h4>
                          </div>
                          <div className="page-btn d-flex align-items-center mt-3 mt-md-0">
                            <div className="d-block d-sm-flex align-items-center">
                              <button
                                onClick={reCalculate}
                                className="btn btn-added downloader mt-3 mb-3 m-sm-0"
                                type="button"
                              >
                                <RefreshCcw className="me-2" />
                                Re-Generate
                              </button>
                            </div>
                            &nbsp;
                            <div className="d-block d-sm-flex align-items-center">
                              <button
                                onClick={submitPayroll}
                                className="btn btn-added mt-3 mb-3 m-sm-0"
                                type="button"
                                disabled={!isReGenerated}
                              >
                                <Save className="me-2" />
                                Save Payroll
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-body custom-modal-body">
                      <div className="card mb-0">
                        <div className="card-body border-0">
                          {/* <div className="payslip-month d-flex">
                                            <div className="slip-logo">
                                                <img src="assets/img/logo-small.png" alt="Logo" />
                                            </div>
                                            <div className="month-of-slip">
                                                <h4>Payslip for the Month of Sep 2023</h4>
                                            </div>
                                        </div> */}

                          <div className="emp-details d-flex">
                            <div className="emp-name-id">
                              <h6>
                                Emp Name : <span>{payrollData?.fullName}</span>
                              </h6>
                              <h6>
                                Emp Id : <span>{payrollData?.uniqueID}</span>
                              </h6>
                              <h6>
                                Department :
                                <span>{payrollData?.departmentName}</span>
                              </h6>
                            </div>
                            <div className="emp-location-info">
                              <h6>
                                Designation :
                                <span>{payrollData?.designationName}</span>
                              </h6>
                              <h6>
                                Salary Type :
                                <span>{payrollData?.salaryType}</span>
                              </h6>
                              <h6>
                                Residential Type :
                                <span>{payrollData?.residentialType}</span>
                              </h6>
                            </div>
                          </div>

                          <div className="row">
                            {/* <div className="table-responsive">
                              <table className="w-100">
                                <tbody className="paysilp-table-borders">
                                  <tr>
                                    <td>Hourly Salary</td>
                                    <td>$32,000</td>
                                    <td>Total Hours Worked</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Monthly Salary</td>
                                    <td>0.00</td>
                                    <td>Normal Working Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Addition</td>
                                    <td>0.00</td>
                                    <td>Deduction</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Employee CPF</td>
                                    <td>0.00</td>
                                    <td>Employer CPF</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>OT1 Salary</td>
                                    <td>0.00</td>
                                    <td>OT1 Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>OT2 Salary</td>
                                    <td>0.00</td>
                                    <td>OT2 Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Public Holiday Salary</td>
                                    <td>0.00</td>
                                    <td>Public Holiday Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Public Holiday OT Salary</td>
                                    <td>0.00</td>
                                    <td>Public Holiday OT Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr>
                                    <td>Additional Hours</td>
                                    <td>0.00</td>
                                    <td>Additional Hours</td>
                                    <td>0.00</td>
                                  </tr>
                                  <tr className="payslip-border-bottom">
                                    <th>Gross Salary</th>
                                    <td>$32,000</td>
                                    <th>Net Pay</th>
                                    <td>0.00</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div> */}

                            <div className="col-md-6">
                              <div className="table-responsive">
                                <table className="w-100">
                                  <thead>
                                    <tr className="paysilp-table-border">
                                      <th colSpan="2">Earnings</th>
                                    </tr>
                                  </thead>
                                  <tbody className="paysilp-table-borders">
                                    {payrollData?.earningsList?.map(
                                      (earning, index) => {
                                        if (earning.amount > 0) {
                                          return (
                                            <tr key={index}>
                                              <td>{earning.description}</td>
                                              <td>
                                                {Number(earning.amount).toFixed(
                                                  2
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      }
                                    )}
                                    <tr className="payslip-border-bottom">
                                      <th>Total Earnings</th>
                                      <td>
                                        $
                                        {Number(
                                          payrollData?.totalEarning
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="table-responsive">
                                <table className="w-100">
                                  <thead>
                                    <tr className="paysilp-table-border">
                                      <th colSpan="2">Deductions</th>
                                    </tr>
                                  </thead>
                                  <tbody className="paysilp-table-borders">
                                    {payrollData?.deductionsLists?.map(
                                      (deduction, index) => {
                                        if (deduction.amount > 0) {
                                          return (
                                            <tr key={index}>
                                              <td>{deduction.description}</td>
                                              <td>
                                                {Number(
                                                  deduction.amount
                                                ).toFixed(2)}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      }
                                    )}
                                    <tr className="payslip-border-bottom">
                                      <th>Total Deduction</th>
                                      <td>
                                        $
                                        {Number(
                                          payrollData?.totalDeduction
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="emp-details d-flex justify-content-start">
                              <div className="emp-name-id pay-slip-salery">
                                <h6>Net Salary</h6>
                                {/* <span>Inwords</span> */}
                              </div>
                              <div className="emp-location-info pay-slip-salery">
                                <h6>${Number(payrollData?.netPay)}</h6>
                                {/* <span>Thirty Two Thousand Only</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card border-0">
            <div className="card-body add-product pb-0">
              <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#payroll-details"
                    data-bs-toggle="tab"
                  >
                    Payroll Details
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#other-details"
                    data-bs-toggle="tab"
                  >
                    Other Details
                  </Link>
                </li>
              </ul>
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="tab-content">
                    <div className="tab-pane show active" id="payroll-details">
                      <PayrollForm />
                    </div>
                    <div className="tab-pane" id="other-details">
                      <PayrollAdditionDeductionForm />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center gap-3 mb-5 mt-5">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={handleSubmit(reCalculate)}
                    >
                      Re-Calculate
                    </button>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PayrollEdit;
